package io.github.jangalinski.pages._2015._07._27

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initConvertFromCamelToSnakeCasePage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("2015/07/27/ConvertFromCamelToSnakeCase.md", FrontMatterElement.Builder { addScalar("title", "Convert test method names from camelCase to snake_case"); addScalar("date", "2015-07-27"); }))
}

@Page("/2015/07/27/convert-from-camel-to-snake-case")
@Layout(".site.components.layout.BlogLayout")
@Composable
fun ConvertFromCamelToSnakeCasePage() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Over the last years I started abandoning the sun coding convention when it comes to test method names. I find the so called snake_case much easier to read then the camelCase.")
    }
    org.jetbrains.compose.web.dom.Pre { org.jetbrains.compose.web.dom.Code { org.jetbrains.compose.web.dom.Text("""public void thisIsWhatTheTestDoes() {...}

public void this_is_what_the_test_does() {...}
""") } }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("But when you just start writing some tests in a new fashion while others continue the old style, you quickly end up doing \"what we have always done\", because no one wants to apply the new convention to all existing tests.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Sounds familiar? Here is a one-liner that solves this problem. It scans all java test files in a directory, looks for lines that start with \"public void\" (assuming these are our test methods) and renames them from camelCase to snake_case.")
    }
    org.jetbrains.compose.web.dom.Pre { org.jetbrains.compose.web.dom.Code { org.jetbrains.compose.web.dom.Text("""find . -type f -name "*Test.java" -exec sed -r -i '/public void/ s/([a-z0-9])([A-Z])/\1_\L\2/g' {} \;
""") } }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Which leads from")
    }
    org.jetbrains.compose.web.dom.Pre { org.jetbrains.compose.web.dom.Code { org.jetbrains.compose.web.dom.Text("""public class DummyTest {
  @Test
  public void thisIsWhatTheTestDoes() {
    int myVariable = 0;
    doSomething(myVariable);
  }
}
""") } }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("to")
    }
    org.jetbrains.compose.web.dom.Pre { org.jetbrains.compose.web.dom.Code { org.jetbrains.compose.web.dom.Text("""public class DummyTest {
  @Test
  public void this_is_what_the_test_does() {
    int myVariable = 0;
    doSomething(myVariable);
  }
}
""") } }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("nicely keeping variable- and non-test-method-names on the way.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("useful-links") }) {
        org.jetbrains.compose.web.dom.Text("Useful links")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://unix.stackexchange.com/questions/112023/how-can-i-replace-a-string-in-a-files") {
                org.jetbrains.compose.web.dom.Text("how-can-i-replace-a-string-in-a-files")
            }
        }
    }
}
